import { render, staticRenderFns } from "./MerchantAgreement.vue?vue&type=template&id=36cf6344&scoped=true"
import script from "./MerchantAgreement.vue?vue&type=script&lang=js"
export * from "./MerchantAgreement.vue?vue&type=script&lang=js"
import style0 from "./MerchantAgreement.vue?vue&type=style&index=0&id=36cf6344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf6344",
  null
  
)

export default component.exports